export const branding = [
  {
    name: "Gold",
    className: "branding-gold",
  },
  {
    name: "Silver",
    className: "branding-silver",
  },
  {
    name: "Bronze",
    className: "branding-bronze",
  },
];
